export const AIRQUALITY_CHART_COLORS = ["#FFD700", "#FFB14E", "#FA8775", "#EA5F94", "#CD34B5", "#9D02D7", "#0000FF", "#50BBF8", "#09D1A1", "#60CB60", "#CB4742"];
export const X_AXIS_LABEL_FORMAT = 'LLL yyyy';
export const AIRQUALITY_TMA_CHART_COLOR = '#CB4742';
//# sourceMappingURL=config.js.map